import Vue from 'vue'
import Router from 'vue-router'
import CollPoll from './components/Routes/CollPoll.vue'
import Login from './components/Routes/Login.vue'
import Home from './components/Routes/Nested_Routes/Home.vue'
import Parents from './components/Routes/Nested_Routes/Parents.vue'
import Students from './components/Routes/Nested_Routes/Students/Students.vue'
import Panel from './components/Routes/Panel.vue'
import Qr from './components/Routes/Qr.vue'
import Recovery from './components/Routes/Recovery.vue'
import Visit from './components/Routes/Visit.vue'
import VisitPoll from './components/Routes/VisitPoll.vue'
import VisitUnauthenticated from './components/Routes/VisitUnauthenticated/VisitUnauthenticated.vue'

import Colleges from './components/Routes/Nested_Routes/CollegesSa/Colleges.vue'
import CreateCollege from './components/Routes/Nested_Routes/CollegesSa/sections/CreateCollege.vue'
import EnableCollege from './components/Routes/Nested_Routes/CollegesSa/sections/EnableCollege.vue'
import SuspendServiceCollege from './components/Routes/Nested_Routes/CollegesSa/sections/SuspendService.vue'
import UpdateCollege from './components/Routes/Nested_Routes/CollegesSa/sections/UpdateCollege.vue'

import ActivityCentre from './components/Routes/Nested_Routes/ActivityCentre.vue'
import Authorizations from './components/Routes/Nested_Routes/Authorizations/Authorizations.vue'
import CreateAuthorizations from './components/Routes/Nested_Routes/Authorizations/createAuthorizations.vue'
import DetailAuthorizations from './components/Routes/Nested_Routes/Authorizations/detailAuthorizations.vue'
import EditAuthorizations from './components/Routes/Nested_Routes/Authorizations/editAuthorizations.vue'
import Checker from './components/Routes/Nested_Routes/Checker.vue'
import classroom from './components/Routes/Nested_Routes/Classroom.vue'
import Configuration from './components/Routes/Nested_Routes/Configuration.vue'
import Devices from './components/Routes/Nested_Routes/Devices.vue'
import Employees from './components/Routes/Nested_Routes/Employee.vue'
import Holidays from './components/Routes/Nested_Routes/Holidays.vue'
import Levels from './components/Routes/Nested_Routes/Levels.vue'
import ReportDetails from './components/Routes/Nested_Routes/Nested_Routes/ReportDetails'
import Notices2 from './components/Routes/Nested_Routes/Noticesnew.vue'
import Payments from './components/Routes/Nested_Routes/Payments.vue'
import PaymentsStudents from './components/Routes/Nested_Routes/PaymentsStudents.vue'
import Polls from './components/Routes/Nested_Routes/Polls.vue'
import Registers from './components/Routes/Nested_Routes/Registers/Registers.vue'
import Reports from './components/Routes/Nested_Routes/Reports.vue'
import Rounds from './components/Routes/Nested_Routes/Rounds/Rounds.vue'
import CreateRound from './components/Routes/Nested_Routes/Rounds/sections/createRound.vue'
import DetailCollegeRound from './components/Routes/Nested_Routes/Rounds/sections/detailCollegeRound.vue'
import EditorCollegeRound from './components/Routes/Nested_Routes/Rounds/sections/editorCollegeRound.vue'
import Statistics from './components/Routes/Nested_Routes/Statistics.vue'
import Subgroups from './components/Routes/Nested_Routes/Subgroups.vue'
import Updates from './components/Routes/Nested_Routes/Updates.vue'
import Visor from './components/Routes/Nested_Routes/Visor.vue'
import workshop from './components/Routes/Nested_Routes/Workshop.vue'
import workshopReport from './components/Routes/Nested_Routes/WorkshopReport.vue'
import Visits from './components/Routes/Nested_Routes/visits/Visits.vue'
import NotFound from './components/Routes/NotFound.vue'
import CreateSchedule from './components/Sections/Checker/CreateSchedule.vue'
import DetailSchedule from './components/Sections/Checker/DetailSchedule.vue'
import UpdateSchedule from './components/Sections/Checker/UpdateSchedule.vue'
import AllReport from './components/Sections/Reports/AllReport.vue'
import AttendanceReport from './components/Sections/Reports/Attendance/Attendance.vue'
import CollaboratorEntriesReport from './components/Sections/Reports/CollaboratorEntries.vue'
import StudentEntriesReport from './components/Sections/Reports/Entries.vue'
import Historic from './components/Sections/Reports/HistoricReport.vue'
import OutingsReport from './components/Sections/Reports/Outings/Outings.vue'
import ParentEntriesReport from './components/Sections/Reports/ParentEntries.vue'
import VisitEntriesReport from './components/Sections/Reports/VisitEntries.vue'
import ThirdAuthorizations from './components/Sections/Reports/thirdAuthorizations/thirdAuthorizations.vue'
import Main from './components/main'

import ModalDisableCollege from './components/Dialogs/ModalDisableCollege.vue'
import SaHome from './components/Routes/Nested_Routes/SaHome.vue'
import Collaborators from './components/Routes/Nested_Routes/collaboratorsSa/Collaborators.vue'
import SaPanel from './components/Routes/SaPanel.vue'
import { i18n } from './plugins/i18n'
import store from './store.js'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/:lang',
      component: Main,
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
        },
        {
          path: 'recovery',
          name: 'Recovery',
          component: Recovery,
        },
        {
          path: 'qr',
          name: 'QR',
          component: Qr,
        },
        {
          path: 'visits/:code',
          name: 'Visit',
          component: Visit,
        },
        {
          path: 'visit_unauthenticated/:uuid_branch',
          name: 'VisitUnauthenticated',
          component: VisitUnauthenticated,
        },
        {
          path: 'PollCollaborator/:id/',
          name: 'PollCollaborator',
          component: CollPoll,
        },
        {
          path: 'PollVisit/:id/',
          name: 'PollVisit',
          component: VisitPoll,
        },
        {
          path: 'sa/panel',
          name: 'saPanel',
          component: SaPanel,
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: 'sa_home',
              name: 'SAHome',
              component: SaHome,
            },
            {
              path: 'colleges',
              name: 'Colleges',
              component: Colleges,
            },
            {
              path: 'college/create',
              name: 'collgesCreate',
              component: CreateCollege,
            },
            {
              path: 'college/update/:id',
              name: 'collegeUpdate',
              component: UpdateCollege,
            },
            {
              path: 'college/suspend/:id',
              name: 'CollegeServiceSuspend',
              component: SuspendServiceCollege,
            },
            {
              path: 'college/enable/:id',
              name: 'CollegeEnable',
              component: EnableCollege,
            },
            {
              path: 'collaborators',
              name: 'Collaborators',
              component: Collaborators,
            },
          ],
        },
        {
          path: 'panel',
          name: 'Panel',
          component: Panel,
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: 'home',
              name: 'Home',
              component: Home,
            },
            {
              path: 'activity',
              name: 'Activity Centre',
              component: ActivityCentre,
            },
            {
              path: 'configuration',
              name: 'Configuration',
              component: Configuration,
            },
            {
              path: 'employee',
              name: 'Employee',
              component: Employees,
            },
            {
              path: 'visor',
              name: 'Visor',
              component: Visor,
            },
            // {
            //   path: 'visor2',
            //   name: 'Visor',
            //   component: Visor2
            // },
            {
              path: 'parents',
              name: 'Parents',
              component: Parents,
            },
            {
              path: 'reports',
              name: 'Reports',
              component: Reports,
            },
            {
              path: 'rounds',
              name: 'Rounds',
              component: Rounds,
            },
            {
              path: 'rounds/create',
              name: 'createRound',
              component: CreateRound,
            },
            {
              path: 'round/detail/:id',
              name: 'detailRound',
              component: DetailCollegeRound,
            },
            {
              path: 'round/edit/:id',
              name: 'editCollegeRound',
              component: EditorCollegeRound,
            },
            {
              path: 'reports/details',
              name: 'Details',
              component: ReportDetails,
            },
            {
              path: 'reports/student-entries',
              name: 'Student Entries',
              component: StudentEntriesReport,
            },
            {
              path: 'reports/parent-entries',
              name: 'Parent Entries',
              component: ParentEntriesReport,
            },
            {
              path: 'reports/visit-entries',
              name: 'Visit Entries',
              component: VisitEntriesReport,
            },
            {
              path: 'reports/collaborator-entries',
              name: 'Collaborator Entries',
              component: CollaboratorEntriesReport,
            },
            {
              path: 'reports/outings',
              name: 'Outings',
              component: OutingsReport,
            },
            {
              path: 'reports/Aforo',
              name: 'AllREport',
              component: AllReport,
            },
            {
              path: 'reports/Attendance',
              name: 'attendanceReport',
              component: AttendanceReport,
            },
            {
              path: 'reports/Historic',
              name: 'AllREport',
              component: Historic,
            },
            {
              path: 'reports/Workshopreport',
              name: 'Workshop report',
              component: workshopReport,
            },
            {
              path: 'reports/third_authorizations',
              name: 'thirdAuthorizations',
              component: ThirdAuthorizations,
            },
            {
              path: 'levels',
              name: 'Levels',
              component: Levels,
            },
            {
              path: 'levels/configuration',
              name: 'LevelsConfig',
              component: Levels,
            },
            {
              path: 'registers',
              name: 'registers',
              component: Registers,
            },
            {
              path: 'devices',
              name: 'Devices',
              component: Devices,
            },
            {
              path: 'notices',
              name: 'Notices',
              component: Notices2,
            },
            {
              path: 'students',
              name: 'Students',
              component: Students,
            },
            {
              path: 'statistics',
              name: 'Statistics',
              component: Statistics,
            },
            {
              path: 'payments',
              name: 'Payments',
              component: Payments,
            },
            {
              path: 'payments/:idPayment',
              name: 'PaymentsStudents',
              component: PaymentsStudents,
            },
            {
              path: 'polls',
              name: 'Polls',
              component: Polls,
            },
            {
              path: 'subgroups',
              name: 'Subgroups',
              component: Subgroups,
            },
            {
              path: 'visits',
              name: 'Visits',
              component: Visits,
            },
            {
              path: 'update',
              name: 'update',
              component: Updates,
            },
            {
              path: 'workshop',
              name: 'Workshop',
              component: workshop,
            },
            {
              path: 'classroom',
              name: 'Classroom',
              component: classroom,
            },
            {
              path: 'Holidays',
              name: 'Holidays',
              component: Holidays,
            },
            {
              path: 'checker',
              name: 'checker',
              component: Checker,
            },
            {
              path: 'checker/detail/:id',
              name: 'scheduleDetail',
              component: DetailSchedule,
            },
            {
              path: 'checker/create',
              name: 'scheduleCreate',
              component: CreateSchedule,
            },
            {
              path: 'checker/update/:id',
              name: 'scheduleUpdate',
              component: UpdateSchedule,
            },
            {
              path: 'authorizations',
              name: 'authorizations',
              component: Authorizations,
            },
            {
              path: 'authorizations/create',
              name: 'createAuthorizations',
              component: CreateAuthorizations,
            },
            {
              path: 'authorizations/edit/:id',
              name: 'editAuthorizations',
              component: EditAuthorizations,
            },
            {
              path: 'authorizations/detail/:id',
              name: 'detailAuthorizations',
              component: DetailAuthorizations,
            },
          ],
        },
        {
          path: 'disable',
          name: 'Disable',
          component: ModalDisableCollege,
        },
      ],
    },

    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
    },
  ],
})

router.beforeEach((to, from, next) => {
  const lang = to.params.lang
  store.state.lang = lang

  if (to.path == '/en/sa/panel' || to.path == '/es/sa/panel')
    return next('sa/panel/sa_home')
  if (to.path == '/en/panel' || to.path == '/es/panel')
    return next('panel/home')
  if (!['en', 'es'].includes(lang)) return next('/es/login')
  if (i18n.locale !== lang) {
    i18n.locale = lang
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()

      const sendAnalytics = GoogleAnalytics.getGoogleAnalyticsId()

      if (sendAnalytics === null) return

      GoogleAnalytics.setRoute(to)
      GoogleAnalytics.pageVisitEvent()
      return
    }

    next('login')
  } else {
    next()
  }
})

export default router
